import request from '../request'
import store from '../../store'

// 仪表盘-当年报废补贴数据 (顶部6项数据)
export function getStatistic(params) {
  return request.get("/largescreen/govbf/statistic", {...params, areaId : store.getters.getactiveRegionObj.areaCode}).then((res) => res);
}

// 年度各类型农机报废补贴额
export function getScrapSubsidy(params) {
  return request.get("/largescreen/govbf/statistic/mcc", {...params, areaId : store.getters.getactiveRegionObj.areaCode}).then((res) => res);
}

// 年度各区域农机报废补贴额
export function getAraeSubsidy(params) {
  return request.get("/largescreen/govbf/statistic/area", {...params, areaId : store.getters.getactiveRegionObj.areaCode}).then((res) => res);
}

// 年度各企业农机报废补贴额
export function getEnterpriseSubsidy(params) {
  return request.get("/largescreen/govbf/statistic/company", {...params, areaId : store.getters.getactiveRegionObj.areaCode}).then((res) => res);
}

// 历年投入资金变化趋势
export function getSubsidyByYear(params) {
  return request.get("/largescreen/govbf/getSubsidyByYear", {...params, areaId : store.getters.getactiveRegionObj.areaCode}).then((res) => res);
}

// 中央投入资金使用/结算比例
export function getSubsidyRatio(params) {
  return request.get("/largescreen/govbf/getSubsidyRatio", {...params, areaId : store.getters.getactiveRegionObj.areaCode}).then((res) => res);
}

// 年度各月资金使用兑付情况
export function getSubsidyUseByYear(params) {
  return request.get("/largescreen/govbf/getSubsidyUseByYear", {...params, areaId : store.getters.getactiveRegionObj.areaCode}).then((res) => res);
}

// 地图各区域报废信息
export function getCompanyDistribute(params) {
  return request.get("/largescreen/govbf/getCompanyDistribute", {...params, areaId : store.getters.getactiveRegionObj.areaCode}).then((res) => res);
}